module.exports = __webpack_public_path__ + "static/media/no-red.37374c91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no-red.svg
// module id = 519
// module chunks = 0